import { useTrackExternalLink } from '@hooks/use-track-external-link'
import { Tabs } from '@ui/atoms/tabs'
import { ENHANCED_COMPONENT_TYPE } from '@ui/enhanced-components/types'
import { SectionTemplate } from '@ui/section-template'
import clsx from 'clsx'
import React, { type FC, useState } from 'react'

import { SimulatorCapacity } from './simulators/capacity/simulator-capacity'
import { SimulatorMonthlyPayment } from './simulators/monthly/simulator-monthly-payment'

const simulators = [
  {
    label: "Évaluer votre capacité d'emprunt",
    value: 'eval-loan-capacity',
    id: 'eval-loan-capacity',
    content: <SimulatorCapacity />,
  },
  {
    label: 'Calculer votre mensualité',
    value: 'calculate-monthly',
    id: 'calculate-monthly',
    content: <SimulatorMonthlyPayment />,
  },
]

const MortgageSimulator: FC = () => {
  const [value, setValue] = useState(simulators[0].value)
  const trackExternalLink = useTrackExternalLink()
  const handleChange = (value: string) => {
    setValue(value)
  }

  return (
    <SectionTemplate>
      <div className="flex items-center justify-center">
        <Tabs items={simulators} selectedItem={value} onChange={handleChange} />
      </div>

      <div className="py-5">
        {simulators?.map((simulator) => (
          <div
            key={simulator.id}
            className={clsx(
              'h-full w-full',
              simulator.value === value ? 'block' : 'hidden'
            )}
          >
            {simulator.content}
          </div>
        ))}
      </div>
      <p className="mt-3 text-085">
        Cette simulation est purement indicative et valable sous réserve de
        l'exactitude des renseignements fournis. Elle ne constitue pas un
        pré-accord de financement et a simplement à vocation à vous aider à
        préparer votre projet. Le taux présenté peut être amené à évoluer à tout
        moment et concerne uniquement un projet de résidence principale.
      </p>
      <div className="mt-3">
        <a
          data-type={ENHANCED_COMPONENT_TYPE.HYPERLINK}
          href="/credit-immobilier/demander-un-pret"
          rel="noreferrer"
          target="_blank"
          className={clsx(
            '!text-theme-info-main',
            'hover:text-theme-selected-accent3 hover:underline',
            'group-[.is-blue]/section-template:!text-text-inverse',
            'group-[.is-blue]/component:!text-text-inverse',
            'group-[.is-blue]/section-template:hover:!text-theme-info-accent1',
            'group-[.is-blue]/component:hover:!text-theme-info-accent1'
          )}
          onClick={trackExternalLink}
        >
          Demander un prêt
        </a>
      </div>
    </SectionTemplate>
  )
}

export default MortgageSimulator
